import { sendPdf } from "@DSG/Services/VmiBinsService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CallApi,
} from "@insite/client-framework/Store/Pages/VmiLocationDetails/Handlers/SendVmiBinsPdf";

replaceInChain(chain, CallApi, async props => {  
   props.apiResult = await sendPdf(props.apiParameter);
});